<template>
  <div id="drawers" @keydown.esc="popDrawer">
    <transition>
      <div v-show="hasContent" class="underlay" @click="popDrawer" />
    </transition>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapMutations } from 'vuex'
@Component({
  computed: {
    ...mapGetters(['drawers'])
  },
  methods: {
    ...mapMutations(['popDrawer'])
  }
})
export default class DrawersContainer extends Vue {
  drawers!: Function
  get hasContent() {
    return Boolean(this.drawers().length)
  }
}
</script>

<style lang="scss">
#drawers {
  .underlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    max-height: 100vh;
    max-height: -webkit-fill-available;
    background-color: $color-scrim;
    z-index: 250;
    transition: opacity 200ms ease;

    &.v-enter {
      opacity: 0;
    }
    &.v-enter-to {
      opacity: 1;
    }
    &.v-leave {
      opacity: 1;
    }
    &.v-leave-to {
      opacity: 0;
    }
  }
  .card-drawer {
    position: absolute;
    margin: auto;
    bottom: 0;
  }
}
</style>
